// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_2M9GG","carousel":"index_carousel_1x7hm"};